const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.LOYALTY_ACTIONS)
const activityGroupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.LOYALTY_ACTIVITIES)

export const apiLoyaltyActions = {
	fetchLoyaltyActionsTypes: async (): Promise<IApiResponseModel<IPointLoyaltyActionTypeModel[]>> => {
		const { data, meta } = await apiCommon<IPointLoyaltyActionType[]>(`${groupPrefix}/types`, { method: 'GET' })

		return { data: data.map(d => PointsLoyaltyActionType(d)), meta }
	},
	assignLoyaltyActionToActivity: async (
		id: number,
		payload: IPointLoyaltyActionCreatePayload,
	): Promise<IPointLoyaltyActionModel> => {
		const { data } = await apiCommon<IPointLoyaltyAction>(`${activityGroupPrefix}/${id}/loyalty-actions`, {
			method: 'POST',
			body: payload,
		})

		return PointsLoyaltyAction(data)
	},
	updateLoyaltyActivityAction: async (
		payload: IPointLoyaltyActionUpdatePayload,
	): Promise<IPointLoyaltyActionModel> => {
		const { data } = await apiCommon<IPointLoyaltyAction>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return PointsLoyaltyAction(data)
	},
}
